export default __webpack_public_path__ + "static/media/les_delete.d66e9b61.svg";